import { validateRecaptcha } from 'helpers/recaptcha'

const contactUsFormValidation = {
  el: {
    contactPage: document.querySelector<HTMLElement>('.contact-page'),
    contactForm: document.querySelector<HTMLFormElement>('.contact-page__form'),
    contactThankYouPage: document.querySelector<HTMLElement>('.contact-page__thank-you'),
    contactError: document.querySelector<HTMLElement>('.contact-page__error'),

    recaptchaForm: document.querySelector<HTMLDivElement>('.form__recaptcha'),
    typeInput: document.querySelector<HTMLInputElement>('.form__type'),

    ssnInput: document.querySelector<HTMLInputElement>('.contact-page__input--ssn'),
    nameInput: document.querySelector<HTMLInputElement>('.contact-page__input--name'),
    emailInput: document.querySelector<HTMLInputElement>('.contact-page__input--email'),
    phoneInput: document.querySelector<HTMLInputElement>('.contact-page__input--phone'),
    messageInput: document.querySelector<HTMLInputElement>('.contact-page__input--message'),
    termsInput: document.querySelector<HTMLInputElement>('.contact-page__input--terms'),
    submitInput: document.querySelector<HTMLButtonElement>('.contact-page__submit-button'),
  },

  init(): void {
    if (this.el.contactForm) {
      this.updateSubmitButtonState()
      this.setListeners()
    }
  },

  updateSubmitButtonState(): void {
    if (this.el.typeInput.value === 'contactUs') {
      if (this.isValidName() && this.isValidMessage() && this.isValidEmail() && this.isValidPhone() && this.isValidSSN() && this.isValidTerms() && this.el.contactForm.checkValidity()) {
        this.el.submitInput.removeAttribute('disabled')
      } else {
        this.el.submitInput.setAttribute('disabled', 'disabled')
      }
    }
  },

  setListeners(): void {
    this.el.contactForm.addEventListener('input', () => {
      this.updateSubmitButtonState()
    })

    this.el.contactForm.addEventListener('submit', (e) => {
      this.submit(e)
    })

    this.el.ssnInput.addEventListener('input', () => {
      this.updateSubmitButtonState()
    })
  },

  isValidName(): boolean {
    return this.el.nameInput.value.length > 0
  },

  isValidMessage(): boolean {
    return this.el.messageInput.value.length > 0
  },

  isValidPhone(): boolean {
    const phoneRegex = /^[1-9]{1}[0-9]{2}(-?)[0-9]{4}$/
    return phoneRegex.test(this.el.phoneInput.value)
  },

  isValidEmail(): boolean {
    const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i
    return emailRegex.test(this.el.emailInput.value)
  },

  isValidSSN(): boolean {
    const ssnRegex = /^[0-9]{6}(-?)[0-9]{4}$/
    return ssnRegex.test(this.el.ssnInput.value)
  },

  isValidTerms(): boolean {
    if (this.el.termsInput.checked) {
      return true
    } else {
      return false
    }
  },

  // Find the closest error div from an input (Input.cshtml)
  // handleInputError(input: HTMLInputElement) {
  //   // Find the closest parent with class 'input-group__wrap'
  //   const inputGroupWrap = input.closest('.input-group__wrap')

  //   // If the input group wrap exists, find the next sibling with class 'input-group__error'
  //   if (inputGroupWrap) {
  //     const errorDiv = inputGroupWrap.nextElementSibling

  //     if (errorDiv && errorDiv.classList.contains('input-group__error')) {
  //       const errorElement = errorDiv as HTMLElement
  //       errorElement.textContent = 'There was an error with your input'
  //       errorElement.style.display = 'block'
  //     }
  //   }
  // },

  async submit(e: SubmitEvent): Promise<void> {
    e.preventDefault()

    const isRecaptchaValid = validateRecaptcha()

    if (!isRecaptchaValid) {
      if (this.el.recaptchaForm) {
        const errorBox = this.el.recaptchaForm.querySelector<HTMLDivElement>('.form__recaptcha-error')

        if (errorBox && errorBox.classList.contains('hide')) {
          errorBox.classList.remove('hide')
        }

        return
      }
    }

    this.el.submitInput.classList.add('loading')
    this.el.submitInput.setAttribute('disabled', '')

    const data = new FormData(this.el.contactForm)
    const formAction = this.el.contactForm.getAttribute('action')
    const formMethod = this.el.contactForm.getAttribute('method')

    const request = await fetch(formAction, {
      method: formMethod,
      body: data,
    })

    if (request.ok) {
      this.el.contactPage.style.display = 'none'
      this.el.contactThankYouPage.style.display = 'inherit'
    } else {
      this.el.contactError.style.display = 'inherit'
    }

    this.el.submitInput.removeAttribute('disabled')
    this.el.submitInput.classList.remove('loading')
  },
}

export default contactUsFormValidation
